<ngx-spinner bdOpacity=0.9 bdColor="#161921" size="medium" color="#ff421d" type="fire" [fullScreen]="true"></ngx-spinner>
<div class="ct" id="t1" [hidden]=preloading>
    <div class="ct" id="t2">
        <div class="ct" id="t3">
            <div class="ct" id="t4">
                <div class="ct" id="t5">
                    <ul id="menu">
                        <a href="#t1" onclick="(function(e){e.preventDefault();location.hash = '#t1'})(event)">
                            <li class="icon fa fa-cloud-download" id="uno"></li>
                        </a>
                        <a href="#t2" onclick="(function(e){e.preventDefault();location.hash = '#t2'})(event)">
                            <li class="icon fa fa-info-circle" id="dos"></li>
                        </a>
                        <a href="#t3" onclick="(function(e){e.preventDefault();location.hash = '#t3'})(event)">
                            <li class="icon fa fa-flag" id="tres"></li>
                        </a>
                    </ul>
                    <div class="page" id="p1">
                        <div class="container-fluid h-100">
                            <div class="row w-100 h-33 align-items-center justify-content-center" *ngIf="!isMobile"></div>
                            <div class="row align-items-center justify-content-center h-33 card-wrapper">
                                <div style="display: flex;" class="col-sm-4 align-items-end justify-content-end" *ngIf="!isMobile">
                                </div>
                                <div class="col-7 col-sm-4">
                                    <div class="card text-white bg-firefile">
                                        <div class="row no-gutters">
                                            <div
                                                class="col-12 col-sm-4 file-icon d-flex p-2 justify-content-center align-items-center">
                                                <mat-icon [svgIcon]="getType() + '-file-custom'" class="file-color"
                                                    [ngClass]="getType() + '-file'"></mat-icon>
                                            </div>
                                            <div class="col-md-8">
                                                <div class="card-body">
                                                    <h5 class="card-title" [title]="canDecrypt ? fileEntry.name : ''">
                                                        {{ canDecrypt ? truncateText(fileEntry.name, 30) : "Wrong decryption key ❌" }}
                                                    </h5>
                                                    <p class="card-text">
                                                        <span class="no-wrap">
                                                            <span class="file-size--loaded"
                                                                [class.file-size--done]=downloadFinished
                                                                [class.file-size--invalid]=!canDecrypt||adblockEnabled
                                                                #downloadProgress></span> /
                                                            <span class="file-size-total"
                                                                [class.file-size--invalid]=!canDecrypt||adblockEnabled>{{ humanFileSize(fileEntry.file_size) }}</span>
                                                        </span>
                                                        <span class="file-type--wrapper no-wrap">
                                                            <span class="file-size--divider"
                                                                [class.file-size--invalid]=!canDecrypt||adblockEnabled>|</span>
                                                            File Type:
                                                            <span class="file-type"
                                                                [class.file-size--invalid]=!canDecrypt||adblockEnabled>{{ fileEntry.type.toUpperCase() }}</span>
                                                        </span>
                                                    </p>
                                                    <div class="btn-container" [hidden]=!canDecrypt||adblockEnabled>
                                                        <a #downloadBtn (click)="startDownload($event)"
                                                            class="button dark">
                                                            <ul class="button--large">
                                                                <li>&#68;ownload</li>
                                                                <li #downloadSpeed>&#68;ownloading</li>
                                                                <li>&#68;ownloaded</li>
                                                            </ul>
                                                            <div>
                                                                <svg viewBox="0 0 24 24"></svg>
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <p class="card-text" [hidden]=!canDecrypt||!adblockEnabled style="color: white; font-size: 1.75rem;">
                                                        ❌ Disable AdBlock to download ❌
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer bg-transparent border-firefile align-items-center"
                                            [hidden]=!canDecrypt>
                                            <share-buttons [theme]="'material-dark'"
                                                [include]="['facebook','twitter','reddit','copy']" [show]="6">
                                            </share-buttons>
                                        </div>
                                    </div>
                                </div>
                                <div style="display: flex;" class="col-sm-4 align-items-start justify-content-start" *ngIf="!isMobile">
                                </div>
                            </div>
                            <div class="row w-100 h-33 align-items-center justify-content-center" *ngIf="!isMobile">
                            </div>
                        </div>
                    </div>
                    <div class="page" id="p2">
                        <section class="icon">
                            <div class="container h-100 w-100">
                                <div class="row align-items-center justify-content-center h-100">
                                    <span class="title">
                                        <i class="fa fa-info-circle"></i>
                                        About {{ fileEntry.type.toUpperCase() }}
                                    </span>
                                    <p class="hint align-self-start" [innerHTML]=getTypeDescription(getType())></p>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="page" id="p3">
                        <div class="container h-100">
                            <div class="row align-items-center justify-content-center h-100"
                                [hidden]=!copyrightFormShown>
                                <iframe name="hidden_iframe" id="hidden_iframe" style="display:none;"></iframe>
                                <form #copyrightForm ngNoForm
                                    action="https://getform.io/f/d7896ada-b0a8-4191-99af-2394a7dd1506"
                                    method="POST" target="hidden_iframe">
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputNameCopyrightOwner">Name of Copyright Owner*</label>
                                            <input name="Name Copyright Owner" type="text" class="form-control"
                                                id="inputNameCopyrightOwner" required>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="inputNameAgentCopyrightOwner">Name of report submitting
                                                agent*</label>
                                            <input name="Agent Name" type="text" class="form-control"
                                                id="inputNameAgentCopyrightOwner" required>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputEmail4">Email*</label>
                                            <input name="Mail" type="email" class="form-control"
                                                id="inputEmail4" placeholder="E-Mail Address" required>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="inputJobTitle">Job Title (if applicable)</label>
                                            <input name="Job Title" type="text" class="form-control"
                                                id="inputJobTitle">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-8">
                                            <label for="inputAddress">Address*</label>
                                            <input name="Address" type="text" class="form-control"
                                                id="inputAddress" placeholder="1234 Main St" required>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label for="inputPhone">Phone*</label>
                                            <input name="entry.2078179669" type="tel" class="form-control"
                                                id="inputPhone" required>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-8">
                                            <label for="inputAddress2">Address 2</label>
                                            <input name="Address 2" type="text" class="form-control"
                                                id="inputAddress2" placeholder="Apartment, studio, or floor">
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label for="inputCountry">Country*</label>
                                            <input name="Country" type="text" class="form-control"
                                                id="inputCountry" required>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputCity">City*</label>
                                            <input name="City" type="text" class="form-control"
                                                id="inputCity" required>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label for="inputState">State*</label>
                                            <input name="State" type="text" class="form-control"
                                                id="inputState" required>
                                        </div>
                                        <div class="form-group col-md-2">
                                            <label for="inputZip">Zip*</label>
                                            <input name="Zip" type="text" class="form-control" id="inputZip"
                                                required>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="gridCheck1" required name="Understand">
                                            <label class="form-check-label" for="gridCheck1">
                                                I understand I may be liable for damages, including costs and attorneys’
                                                fees, if I knowingly and materially misrepresent that the reported
                                                content, URL(s), or files are infringing.
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="gridCheck2" required name="Accurate">
                                            <label class="form-check-label" for="gridCheck2">
                                                The information in this notification is accurate, and I state under
                                                penalty of perjury that I am authorized to act on behalf of the
                                                copyright owner.
                                            </label>
                                        </div>
                                    </div>
                                    <span>* required</span>
                                    <br>
                                    <input name="URL" type="text" hidden=true [value]=link />
                                    <br>
                                    <button (click)="onCopyrightFormSubmit($event)" type="submit"
                                        class="btn btn-lg btn-firefile-dark"
                                        [disabled]=copyrightFormSubmitted>{{ copyrightFormSubmitted ? "Submitted!" : "Submit Copyright Report" }}</button>
                                </form>
                            </div>
                            <div class="row align-items-center justify-content-center h-100"
                                [hidden]=copyrightFormShown>
                                <div>
                                    <span class="title">
                                        Copyright
                                    </span>
                                    <br>
                                    Notice of Alleged Infringement "Notice"
                                    <br><br>
                                    We (FIREFILE.CC) respect the copyright of others and require that users of our
                                    services comply with the laws of copyright. You are strictly prohibited from using
                                    our services to infringe copyright. You may not upload, download, store, share,
                                    display, stream, distribute, email, link to, transmit or otherwise make available
                                    any files, data, or content that infringes any copyright or other proprietary rights
                                    of any person or entity. We will respond to notices of alleged copyright
                                    infringement that comply with applicable law and are properly provided to us. If you
                                    believe that your content has been copied or used in a way that constitutes
                                    copyright infringement, please provide us with the following information:
                                    <br><br>
                                    <b>This notification is a serious legal document - please be careful to be accurate
                                        in your copyright infringement claims. You may wish to first consult with an
                                        attorney to determine whether the content you are reporting is in fact
                                        infringing and not protected by fair use, license, or other legal basis.</b>
                                    <br><br>
                                    1. A physical or electronic signature of the copyright owner or a person authorized
                                    to act on their behalf;
                                    <br><br>
                                    2. Dentification of the copyrighted work claimed to have been infringed;
                                    <br><br>
                                    3. Identification of the material that is claimed to be infringing or to be the
                                    subject of infringing activity and that is to be removed or access to which is to be
                                    disabled, and information reasonably sufficient to permit us to locate the material
                                    including for example the uniform resource locator(s) (URL);
                                    <br><br>
                                    4. Your contact information, including your address, telephone number, and an email
                                    address;
                                    <br><br>
                                    5. A statement by you that you have a good faith belief that use of the material in
                                    the manner complained of is not authorized by the copyright owner, its agent, or the
                                    law;
                                    <br><br>
                                    6. A statement that the information in the notification is accurate, and, under
                                    penalty of perjury (unless applicable law says otherwise), that you are authorized
                                    to act on behalf of the copyright owner.
                                    <br><br>
                                    <button (click)=showCopyrightForm() class="btn btn-lg btn-firefile-dark">I
                                        understand</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<form [formGroup]="recaptchaGormGroup">
    <ngx-invisible-recaptcha #captchaElem [siteKey]="recaptchaKey" (success)="handleSuccess($event)"
        [useGlobalDomain]="false" badge="bottomleft" theme='dark' [ngModel]="recaptcha"
        [ngModelOptions]="{ standalone: true }">
    </ngx-invisible-recaptcha>
</form>
<mopinion
    formId="2u8zng67bxwd4uavhcuk2o2jfaice5qpd8q"
></mopinion>
<adcash-popunder
    zoneId="3235207"
    *ngIf="!isDev"
></adcash-popunder>
<ad-banner
    src="https://cdn.onesignal.com/sdks/OneSignalSDK.js"
></ad-banner>
